/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingCostAndUsageAggregationRequest extends models.BillingAggregationBase {
    getFixupPrototypeFunction() { return BillingCostAndUsageAggregationRequest.fixupPrototype; }

    static newInstance(model: Partial<BillingCostAndUsageAggregationRequest>): BillingCostAndUsageAggregationRequest {
        let obj = Object.assign(new BillingCostAndUsageAggregationRequest(), model);
        BillingCostAndUsageAggregationRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingCostAndUsageAggregationRequest>): BillingCostAndUsageAggregationRequest {
        if (!model) return null;
        return BillingCostAndUsageAggregationRequest.newInstance(<BillingCostAndUsageAggregationRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingCostAndUsageAggregationRequest) {
        if (!obj) return;

        models.BillingCostAndUsageAggregationRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingCostAndUsageAggregationRequest): boolean {
        if (models.BillingAggregationBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BillingCostAndUsageAggregationRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.granularity === undefined) {
            this.granularity = 0;
        }
        if (this.limit === undefined) {
            this.limit = 0;
        }
        if (this.group_by) {
            for (let val of this.group_by) {
                models.BillingGroupByDetails.fixupPrototype(val);
            }
        }
    }

    /**
     * Number of seconds between steps
     */
    granularity: number;

    /**
     * Billing plan to select data from
     */
    billing_source: string;

    /**
     * If set, the dimensions to group results by
     */
    group_by: Array<models.BillingGroupByDetails>;

    /**
     * If set, the descriptions of line items will be included in the results.
     */
    include_charge_description: boolean;

    /**
     * If set, limits the results to given number.
     */
    limit: number;

}
